import React from 'react';
import { useTranslation } from 'react-i18next';

import { BackHeader } from '../../../../components';
import { ROUTE } from '../../../../routes';
import { useBackToHub } from '../../../website/hub-navigation';

export type MarketingAreaHeaderProps = {
  /** The area on screen's name, already translated. */
  title: string;
};

/**
 * A Marketing area page's header, as a Website area's: the app's drilldown header (`BackHeader`), its back button
 * going to the Marketing hub (it pops back when the area was opened from the hub, so the page slides back, and pushes
 * the hub otherwise) and the area's name as its centred title. Moving between areas goes through the hub. Rendered
 * unwrapped: BackHeader is sticky, and it pins under the top bar only while its parent is the page column.
 */
export const MarketingAreaHeader = ({ title }: MarketingAreaHeaderProps): React.ReactElement => {
  const { t } = useTranslation();
  const backToMarketing = useBackToHub(ROUTE.marketingAssets());
  return <BackHeader title={title} backLabel={t('Back to Marketing')} onBack={backToMarketing} />;
};

export default MarketingAreaHeader;
